var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-col',{staticClass:"cont",attrs:{"span":24}},[_c('span',{staticClass:"title"},[_vm._v("404")]),_c('br'),_c('span',{staticClass:"body"},[_vm._v("Page does not exist")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }